<template>
    <tr v-if="o === n">
        <td align="center"></td>
        <td align="center">
            <drag-and-drop @fileDropped="openCropWithNewFile">
                <div class="imageCropper" :style="'width:'+width+'px; height:'+height+'px ;margin-left: auto; margin-right: auto; margin-bottom: 3px'">
                    <button v-show="res !== ''" class="resetBtn small redHover" tooltip="Удалить" @click="imageCropperDelete"><i class="fas fa-trash-can"></i></button>
                    <img :src="res ? path + res : ''"
                         :width="width"
                         :height="height"
                         @click="imageCropperOpen"
                         :style="`cursor: pointer; background-image: url(/_assets/${emptyImgName}); object-fit: cover; background-size: cover; background-position: center;`" />
                </div>
            </drag-and-drop>
        </td>
        <td align="center"></td>
        <image-cropper
            ref="cropper"
            :img="res ? res : ''"
            :width="width" :height="height" :widthBox="widthBox"
            :type="type"
            :cropBoxDataLeft="cropBoxDataLeft"
            @canceled="cropCanceled"
            @crop-upload-success="cropUploadSuccess"
            :upload-url="'/imageCropperNew/'+type"
        />
    </tr>
    <tr v-else>
        <td :class="{'selected': res === o}" align="center">
            <a @click="res = o">
                <img :src="o ? path + o : ''" :width="width" :height="height" style="background-color: #f3f3f3" />
            </a>
        </td>
        <td class="selected" align="center">
            <drag-and-drop @fileDropped="openCropWithNewFile">
                <div class="imageCropper" :style="'width:'+width+'px; height:'+height+'px ;margin-left: auto; margin-right: auto; margin-bottom: 3px'">
                    <button v-show="res !== ''" class="resetBtn small redHover" tooltip="Удалить" @click="imageCropperDelete"><i class="fas fa-trash-can"></i></button>
                    <img :src="res ? path + res : ''"
                         :width="width"
                         :height="height"
                         @click="imageCropperOpen"
                         :style="`cursor: pointer; background-image: url(/_assets/${emptyImgName}); object-fit: cover; background-size: cover; background-position: center;`" />
                </div>
            </drag-and-drop>
        </td>
        <td :class="{'selected': res === n}" align="center">
            <a @click="res = n">
                <img :src="n ? path + n : ''" :width="width" :height="height" style="background-color: #f3f3f3" />
            </a>
        </td>
        <image-cropper
            ref="cropper"
            :img="res ? res : ''"
            :type="type"
            :width="width" :height="height" :widthBox="widthBox"
            :cropBoxDataLeft="cropBoxDataLeft"
            @canceled="cropCanceled"
            @crop-upload-success="cropUploadSuccess"
            :upload-url="'/imageCropperNew/'+type"
        />
    </tr>
</template>
<script>
import ImageCropper from '@base/ImageCropper.vue';
import Base from "../Base.vue";
import StrPropsFNO from "../StrPropsFNO.vue";
import dragAndDrop from '@base/DragAndDrop.vue';
export default {
    mixins:[Base,StrPropsFNO],
    components: {ImageCropper, dragAndDrop},
    data: function () {
        return {
            type: this.params.imgType,
            path: this.params.path ?? '',
            width: this.params.width ?? 150,
            height: this.params.height ?? 150,
            widthBox: this.params.widthBox ?? 400,
            emptyImgName: this.params.emptyImgName ?? 'pic_clinic.svg',
            cropBoxDataLeft:  this.params.cropBoxDataLeft ?? 125,
        }
    },
    methods: {
        openCropWithNewFile: function (file) {
            this.$refs.cropper.preloadFile(file);
            this.$refs.cropper.showModal();
        },
        cropUploadSuccess: function (imageUrl, field) {
            this.res = imageUrl;
            this.full.newImgFile = null;
            this.full.oldImg = undefined;
        },
        imageCropperDelete: function (event) {
            this.$modal("Удалить фото?", {
                    name: 'Удалить',
                    callback: () => {
                        this.res = '';
                    }
                },
                {
                    name: 'Нет'
                }
            );
        },
        imageCropperOpen: function () {
            if(this.res=== ''){
                this.$refs.cropper.showFileChooser();
            }else{
                this.$refs.cropper.showModal();
            }
        },
        cropCanceled: function () {
            this.full.newImgFile = null;
            if (this.full.oldImg !== undefined) {
                this.full.img = this.full.oldImg;
                this.full.oldImg = undefined;
            }
        }
    },
    watch: {
        full: {
            handler(value) {
                if (value.sex) {
                    this.emptyImgName = value.sex === 'FEMALE' ? 'pic_she.svg' : 'pic_he.svg';
                }

                setTimeout(() => {
                    if (value.newImgFile && !this.$refs.cropper.$refs.dialog.visible) {
                        this.openCropWithNewFile(value.newImgFile);
                    }
                }, 2000)
            },
            deep: true
        }
    }
}
</script>
